export const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export const hasProps = (jsx) =>
    Object.prototype.hasOwnProperty.call(jsx, "props");

const reduceJsxToString = (previous, current) =>
    previous + innerText(current);

export const innerText = (jsx) => {
    // Empty
    if (
        jsx === null ||
        typeof jsx === "boolean" ||
        typeof jsx === "undefined"
    ) {
        return "";
    }

    // Numeric children.
    if (typeof jsx === "number") {
        return jsx.toString();
    }

    // String literals.
    if (typeof jsx === "string") {
        return jsx;
    }

    // Array of JSX.
    if (Array.isArray(jsx)) {
        return jsx.reduce(reduceJsxToString, "");
    }

    // Children prop.
    if (
        hasProps(jsx) &&
        Object.prototype.hasOwnProperty.call(jsx.props, "children")
    ) {
        return innerText(jsx.props.children);
    }

    // Default
    return "";
}
